<div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">&times;</button>
    <h4 class="modal-title wrap-text-in">Candidates Based on Score</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12">
            <div class="main-box">
                <div class="main-box-body" style="height: 500px; overflow-y: scroll">
                    <div *ngIf="!loadingFlag && candidates.length > 0" style="padding-top: 20px;">
                        <div class="row">
                            <div class="col-xs-3" *ngFor="let candidate of candidates">
                                <div class="main-box clearfix profile-box-menu">
                                    <div class="main-box-body clearfix">
                                        <div class="profile-box-header associate-candidate-card-header clearfix" [ngClass]="{'blue-bg': !candidate.selectedFlag, 'associate-candidate-selected-card-bg': candidate.selectedFlag}">
                                            <div>
                                                <div class="clearfix">
                                                    <div class="pull-left associate-candidate-card-name-div">
                                                        <div class="text-overflow-ellipsis" tooltip="{{candidate.name}}" placement="auto bottom-left">
                                                            {{candidate.name}}
                                                        </div>
                                                        <div class="associate-candidate-card-phone text-overflow-ellipsis" tooltip="{{candidate.mobilePhone}}" placement="auto top-left">
                                                            <i class="fa fa-phone fa-sm"></i>
                                                            <span>{{candidate.mobilePhone}}</span>
                                                        </div>
                                                        <div class="associate-candidate-card-email text-overflow-ellipsis" placement="auto top-left" tooltip="Email {{candidate.email}}">
                                                            <a href="mailto:{{candidate.email}}">
                                                                <i class="fa fa-envelope"></i> {{candidate.email}}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="associate-candidate-card-last-modified-date-div">
                                                    <div class="associate-candidate-card-last-modified-date text-overflow-ellipsis"
                                                         tooltip="{{candidate.lastModifiedDate | fourDotFiveTimeStampFormatPipe}}"
                                                         placement="auto top-left">
                                                        <span>
                                                            Last Modified: {{candidate.lastModifiedDate | fourDotFiveTimeStampFormatPipe}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="profile-box-content clearfix">
                                            <ul class="menu-items">
                                                <li>
                                                    <div class="row associate-candidate-card-popovers-container" style="padding: 5px;">
                                                        <div class="col-xs-6 text-left">
                                                            <div class="text-center" tooltip="Job Match Score" placement="auto top-left" style="margin-right: 40px;">
                                                                <span class="associate-candidate-card-match-score" *ngIf="candidate.currentJobScore != 'N/A'"
                                                                      [ngClass]="{'associate-candidate-card-match-score-success green-bg': candidate.intelligenceScorePassFlag, 'associate-candidate-card-match-score-failure': !candidate.intelligenceScorePassFlag}">{{candidate.currentJobScore}}</span>
                                                                <span class="associate-candidate-card-match-score-na" *ngIf="candidate.currentJobScore == 'N/A'">
                                                                    N/A
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div class="col-xs-6 text-right">
                                                            <div class="pointer associate-candidate-card-job-matches-icon" style="margin-right: 10px;">
                                                                <a href="javascript:void(0)" class="clearfix candidate-card-recruiter-count pointer" popoverTitle="Job Matches"
                                                                   [popover]="jobMatchesPopover" [popoverContext]="{ candidate: candidate }"
                                                                   placement="{{candidate.jobMatchesPopoverPosition}}" containerClass="associate-candidate-card-job-matches-popover" triggers="outsideClick" container="body">
                                                                    <span tooltip="Job Matches">
                                                                        <i class="fa fa-briefcase" style="width: 1em"></i>
                                                                        <span>{{candidate.candidateJobMatches.length}}</span>
                                                                    </span>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!loadingFlag && candidates.length == 0" style="padding: 30px">
                        <div class="row">
                            <div class="col-xs-12 text-center">
                                No Candidates found !
                            </div>
                        </div>
                    </div>
                    <div *ngIf="loadingFlag" style="padding: 30px">
                        <div class="skeleton-container" *ngFor="let i of [1,2,3]">
                            <div class="skeleton-paragraph width-100 skeleton-loading mb-3"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #jobMatchesPopover let-candidate="candidate">
    <div>
        <div class="row" *ngIf="candidate.candidateJobMatches.length > 0">
            <div class="col-xs-12">
                <div class="row" class="candidate-job-match-row">
                    <div class="col-xs-3 candidate-job-match-header-text">
                        Job Title
                    </div>
                    <div class="col-xs-2 candidate-job-match-header-text">
                        {{clientOrBuLabel}}
                    </div>
                    <div class="col-xs-1 candidate-job-match-header-text">
                        Score
                    </div>
                    <div class="col-xs-3 candidate-job-match-header-text">
                        Step
                    </div>
                    <div class="col-xs-3 candidate-job-match-header-text">
                        State
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="candidate.candidateJobMatches.length > 0">
            <div class="col-xs-12" *ngFor="let jobMatch of candidate.candidateJobMatches">
                <div class="row candidate-job-match-row">
                    <div class="col-xs-3 candidate-job-match-text" tooltip="{{jobMatch.title}}">{{jobMatch.title}}</div>
                    <div class="col-xs-2 candidate-job-match-text" tooltip="{{jobMatch.company}}">{{jobMatch.company}}</div>
                    <div class="col-xs-1 candidate-job-match-text" tooltip="{{jobMatch.intelligentScore}}">{{jobMatch.intelligentScore}}</div>
                    <div class="col-xs-3 candidate-job-match-text" tooltip="{{jobMatch.currentStep}}">{{jobMatch.currentStep}}</div>
                    <div class="col-xs-3 candidate-job-match-text" tooltip="{{jobMatch.currentState}}">{{jobMatch.currentState}}</div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="candidate.candidateJobMatches.length == 0">
            <div class="col-xs-12 text-center">
                No Job Matches found!
            </div>
        </div>
    </div>
</ng-template>
